import tosZh from "./tos.json";
import zh from "./zh.json";

export default {
  ...zh,
  ...tosZh,
};
